import { render, staticRenderFns } from "./storedata.vue?vue&type=template&id=00b7de1e"
import script from "./storedata.vue?vue&type=script&lang=js"
export * from "./storedata.vue?vue&type=script&lang=js"
import style0 from "./storedata.vue?vue&type=style&index=0&id=00b7de1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports